
import { defineComponent, ref, watch, onMounted } from 'vue'
import { DateTimeHelper } from '@/helper/dateTime'

export default defineComponent({
  name: 'PostEditTimer',
  emits: ['time-is-up'],
  components: {},
  props: {
    initTimerCount: {
      type: Number,
      required: true,
    },
    onlyLastMinuteSeconds: {
      type: Boolean,
    },
  },
  setup(props, context) {
    const timerCount = ref<number>(props.initTimerCount)
    const minutes = ref<number | undefined>(undefined)
    const paused = ref<boolean>(false)
    const seconds = ref<string | undefined>(undefined)
    const initStamp = DateTimeHelper.getCurrentTimestamp()

    const computeSecondsAndMinutes = () => {
      minutes.value = Math.floor(timerCount.value / 60)
      if (minutes.value > 0) {
        seconds.value = String(timerCount.value - minutes.value * 60).padStart(
          2,
          '0'
        )
      } else {
        seconds.value = String(timerCount.value - minutes.value * 60)
      }
    }

    onMounted(() => computeSecondsAndMinutes())

    watch(
      timerCount,
      value => {
        if (value > 0 && !paused.value) {
          setTimeout(() => {
            timerCount.value--
            computeSecondsAndMinutes()
          }, 1000)
        }

        if (value <= 0) {
          context.emit('time-is-up')
        }
      },
      { immediate: true }
    )

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        paused.value = true
      } else if (paused.value) {
        timerCount.value =
          props.initTimerCount -
          (DateTimeHelper.getCurrentTimestamp() - initStamp)
        computeSecondsAndMinutes()
        paused.value = false
      }
    })

    return {
      paused,
      minutes,
      seconds,
      timerCount,
    }
  },
})
